export const ROW_KEY = "id";
export const SCROLL_SIZE = "100vh";

export const CONSIGNMENT_ITEMS_COLUMN = "consignment_items";
export const INVOICE_COLUMN = "invoice";
export const CARGO_QUANTITY = "cargo_quantity";
export const WARRANTY = "warranty";
export const CLIENT = "client";
export const CLIENT_ID = "client_id";
export const DEPARTMENT_ID = "department_id";

export const NOT_DRAGGABLE_CLASS_NAME = "not-draggable";

export const BRUTTO_COLUMN = "brutto";
